"use client";

import Brands from "@/components/common/Brands";
import ContactForm from "@/components/contact/ContactForm";
import CareersForm from "@/components/careers/CareersForm";
import ContactInfo from "@/components/contact/ContactInfo";
import Map from "@/components/contact/Map";
import Footer1 from "@/components/footers/Footer1";
import Header2 from "@/components/headers/Header2";

import Image from "next/image";
import Link from "next/link";
import { useState, useEffect } from "react";
import { BsInstagram } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";

export default function Page() {
  const [contactData, setContactData] = useState(null);
  const [webContentData, setWebContentData] = useState(null);

  useEffect(() => {
    document.title = "Contact || Arena Water Park";

    const fetchContactData = async () => {
      try {
        const response = await fetch("/api/contactus");
        const webContentResponse = await fetch("/api/web-content");
        const data = await response.json();
        const fetchedWebContent = await webContentResponse.json();
        if (Array.isArray(data) && data.length > 0) {
          setContactData(data[0]);
        }
        if (fetchedWebContent) {
          setWebContentData(
            Array.isArray(fetchedWebContent)
              ? fetchedWebContent[0]
              : fetchedWebContent,
          );
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchContactData();
  }, []);

  return (
    <>
      <div
        className="breadcrumb-wrapper bg-cover"
        style={{
          backgroundImage: contactData?.banner ? `url(${contactData.banner})` : "none",
        }}
      >
        <div className="shape-image float-bob-y"></div>

        <div className="container">
          <div className="breadcrumb-wrapper-items">
            <div className="page-heading">
              <div className="breadcrumb-sub-title">
                <h1 className="wow fadeInUp" data-wow-delay=".3s">
                  {"Contact"}
                </h1>
              </div>

              <ul
                className="breadcrumb-items wow fadeInUp"
                data-wow-delay=".5s"
              >
                <li>
                  <Link href="/">Home</Link>
                </li>
                <li>
                  <i className="fa-sharp fa-solid fa-slash-forward" />
                </li>
                <li>Contact</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="container py-5">
        <div className="row contactinfobox">
          <div className="col-lg-6">
            <div className="card">
              <div className="card-body">
                <h4>{contactData?.title}</h4>
                {/* <div className="row pb-2">
                  <div className="col-3">Phone</div>
                  <div className="col-9">{contactData?.mobile}</div>
                </div> */}
                <div className="row pb-2">
                  <div className="col-3">Email</div>
                  <div className="col-9">{contactData?.email}</div>
                </div>
                <div className="row pb-2">
                  <div className="col-3">Address</div>
                  <div className="col-9">{contactData?.parklocation}</div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-lg-12">
                    <ul className="contactsocialicons">
                      <li>
                        <Link
                          href={webContentData?.socialLinks?.facebook || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaFacebookF />
                        </Link>
                      </li>
                      <li>
                        <Link
                          href={webContentData?.socialLinks?.instagram || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <BsInstagram />
                        </Link>
                      </li>
                      <li>
                        <Link
                          href={webContentData?.socialLinks?.youtube || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaYoutube />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {contactData?.contacts.map((contact, index) => (
              <div className="card" key={index}>
                <div className="card-body">
                  <h4>{contact.name}</h4>
                  <div className="row pb-2">
                    <div className="col-3">Phone</div>
                    <div className="col-9">{contact.mobile}</div>
                  </div>
                  <div className="row pb-2">
                    <div className="col-3">Email</div>
                    <div className="col-9">{contact.email}</div>
                  </div>
                </div>
              </div>
            ))}
            <Map />
            {/* <div className="card">
              <div className="card-body">
                <h4>Arena Restaurent</h4>
                <div className="row pb-2">
                  <div className="col-3">Phone</div>
                  <div className="col-9">+91 1111111111</div>
                </div>
                <div className="row pb-2">
                  <div className="col-3">Email</div>
                  <div className="col-9">niranjanbudi@gmail.com</div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <h4>Arena Foodin</h4>
                <div className="row pb-2">
                  <div className="col-3">Phone</div>
                  <div className="col-9">+91 1111111111</div>
                </div>
                <div className="row pb-2">
                  <div className="col-3">Email</div>
                  <div className="col-9">niranjanbudi@gmail.com</div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <h4>Arena Gaming Zone</h4>
                <div className="row pb-2">
                  <div className="col-3">Phone</div>
                  <div className="col-9">+91 1111111111</div>
                </div>
                <div className="row pb-2">
                  <div className="col-3">Email</div>
                  <div className="col-9">niranjanbudi@gmail.com</div>
                </div>
              </div>
            </div> */}
          </div>
          <div className="col-lg-6">
            <div className="card">
              <div className="card-body">
                <span className="movies-mini-title">
                  <span className="mini-dot"></span>Contact Us
                </span>
                <h4 style={{ fontSize: "45px" }}>
                  Let the fun begin at Arena Water Park!
                </h4>
                <p>
                  "Have questions, feedback or special requests? We are happy to
                  help. Our team is here to assist you in planning the perfect
                  visit and making sure the excitement never stops."
                </p>
                <hr />
                <div className="row">
                  <div className="col-lg-12">
                    <ul className="contactsocialicons">
                      <li>
                        <Link
                          href={webContentData?.socialLinks?.facebook || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaFacebookF />
                        </Link>
                      </li>
                      <li>
                        <Link
                          href={webContentData?.socialLinks?.instagram || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <BsInstagram />
                        </Link>
                      </li>
                      <li>
                        <Link
                          href={webContentData?.socialLinks?.youtube || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaYoutube />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-12">
                <ContactForm />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <CareersForm />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <ContactInfo />
      <ContactForm />
       */}
    </>
  );
}
